
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kisisel-verilerin-korunmasi",
      function () {
        return require("private-next-pages/kisisel-verilerin-korunmasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kisisel-verilerin-korunmasi"])
      });
    }
  